/**
 * Normalizes routes by replacing dynamic segments that start with "te_" or "si_" with placeholders for consistent analytics tracking.
 * Only transaction IDs (te_) and statement IDs (si_) with the specific format are normalized - all other path segments remain unchanged.
 *
 * Examples:
 * - /transaction-event/te_23gfak1dj98cr23hecna2oisotm1sb8a8d → { normalizedPath: '/transaction-event/[id]', parameters: { id: 'te_23gfak1dj98cr23hecna2oisotm1sb8a8d' } }
 * - /statements/si_f73f3439a6844316af7921e77b7ab0c5 → { normalizedPath: '/statements/[id]', parameters: { id: 'si_f73f3439a6844316af7921e77b7ab0c5' } }
 */

interface NormalizedRoute {
  normalizedPath: string
  parameters: Record<string, string>
}

// Pre-compiled pattern for performance - matches te_ or si_ followed by alphanumeric characters
// si_ - Statement ID
// te_ - Transaction Event ID
// st_ - Payment ID?
const DYNAMIC_SEGMENT_PATTERN = /\/((?:te_|si_|st_)[a-z0-9]+)(?=\/|$)/

export function normalizeRoute(pathname: string): NormalizedRoute {
  // Early exit optimization - check for path segment patterns
  if (!pathname.includes('/te_') && !pathname.includes('/si_') && !pathname.includes('/st_')) {
    return {
      normalizedPath: pathname,
      parameters: {},
    }
  }

  // Find the single ID match
  const match = DYNAMIC_SEGMENT_PATTERN.exec(pathname)

  if (match && match[1]) {
    const fullMatch = match[0] // '/te_abc123...'
    const id = match[1] // 'te_abc123...' (without the /)

    return {
      normalizedPath: pathname.replace(fullMatch, '/[id]'),
      parameters: { id: id },
    }
  }

  return {
    normalizedPath: pathname,
    parameters: {},
  }
}
